import { $WC, $DKD } from '@/conf/common.const.js';

export default {
    // 재난 안전 목록
    fetchSafetyList(q) {
        if(typeof q !== $WC.UNDEF && q != '') {
            q = "?dataKdSqno=" + $DKD.SAFETY + "&" + q;
        } else {
            q = "?dataKdSqno=" + $DKD.SAFETY;
        }

        return axios.get($WC.apiBaseURL + "/realtime/safety" + q);
    },

    // 재난 안전 상세
    fetchSafety(registerNo) {
        let url = $WC.apiBaseURL + "/realtime/safety/" + registerNo  + "?dataKdSqno=" + $DKD.SAFETY;
        url += "&histDataKdSqno=" + $DKD.SAFETY_HIST;

        return axios.get(url);
    },

    // 돌발 목록
    fetchAccidentList(onlyActive, q) {
        let url = $WC.apiBaseURL + "/repos/" + $DKD.ACCIDENT + "/data";
        let queryString = "";

        if(onlyActive == 1) {
            queryString += "?searchActivityYn=1";
        } else if(onlyActive == 0) {
            queryString += "?searchActivityYn=0";
        }

        if(typeof q !== 'undefined') {
            if(queryString === '') {
                queryString += "?";
            }
            queryString += q;
        }
        url += queryString;

        return axios.get(url);
    },

    // 돌발 카테고리 설정
    configAccidentCategory(accident) {
        let type = accident.val2;

        if(['A01', 'A03', 'A05', 'A06', 'A07'].includes(type)) {
            accident.accidentCategoryCd = "traffic";
            accident.accidentCategoryNm = "교통사고";
            return true;
        }
        // 집회 및 행사
        else if(['A10'].includes(type)) {
            accident.accidentCategoryCd = "event";
            accident.accidentCategoryNm = "집회및행사";
            return true;
        }
        // 공사
        else if(['A04'].includes(type)) {
            accident.accidentCategoryCd = "construction";
            accident.accidentCategoryNm = "공사";
            return true;
        }
        // 차량고장
        else if(['A02'].includes(type)) {
            accident.accidentCategoryCd = "cartrouble";
            accident.accidentCategoryNm = "차량고장";
            return true;
        } else {
            return false;
        }
    },

    // 현재 기상 상태
    fetchAirSpace() {
        return axios.get($WC.apiBaseURL + "/realtime/airSpace");
    },

    // 날씨 예보
    fetchWeatherForecast(yyyymmdd, hhmm) {
        let url = $WC.apiBaseURL + "/realtime/weatherForecast?dataKdSqno=" + $DKD.WEATHER_FORECAST;
        url += "&yyyymmdd=" + yyyymmdd;
        url += "&hhmm=" + hhmm;

        return axios.get(url);
    },

    // 수질 정보 목록
    fetchLatestWaterQualityList() {
        let url = $WC.apiBaseURL + "/realtime/latestWaterQuality?";
        url += 'waterQualityKdSqno=' + $DKD.WATER_QUALITY;
        url += '&reservoirKdSqno='  + $DKD.WATER_RESERVOIR;
        url += '&faucetKdSqno=' +   + $DKD.WATER_FAUCET;

        return axios.get(url);
    },

    //  물가 정보
    fetchPriceInfo() {
        let url = $WC.apiBaseURL + "/realtime/priceInfo";
        return axios.get(url);
    }
}
